'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('mailprefs', {
        url: '/mailprefs?jwt',
        templateUrl: 'app/mailprefs/mailprefs.html',
        controller: 'MailPrefsCtrl',
      });
  });